import PermissionData = App.Data.PermissionData;
import UserData = App.Data.UserData;

export function mergeAuthenticatedUser(
    user: UserData,
    userWithTenants: UserData,
    activeTenantSlug?: string | null,
    activeTenantPermissions?: PermissionData[]
): UserData {
    return {
        ...user,
        tenants: (userWithTenants.tenants ?? []).map((tenant) => {
            const tenantWithoutPermissions = { ...tenant };
            delete tenantWithoutPermissions.userPermissions;

            if (tenant.slug_name === activeTenantSlug && activeTenantPermissions) {
                return {
                    ...tenantWithoutPermissions,
                    userPermissions: activeTenantPermissions,
                };
            }

            return tenantWithoutPermissions;
        }),
    };
}
